/**
 * AOM Analytics — GA4 section visibility tracking.
 *
 * Fires aom_section_view once per [data-aom-section-id] element that is >=50%
 * visible for 500ms, and aom_section_engage after 2.5s of uninterrupted
 * visibility. window.aomTrack is defined inline in layout/theme.liquid.
 *
 * Usage: put on the wrapping element of a widget:
 *   data-aom-section-id="bundle"
 *   data-aom-section-type="bundle"
 *   data-aom-section-order="1"   (optional, defaults to DOM order)
 */
(function () {
  'use strict';

  var fired = new Set();
  var engaged = new Set();

  function resolveOrder(el, allSections) {
    var explicitOrder = parseInt(el.dataset.aomSectionOrder, 10);
    if (!isNaN(explicitOrder) && explicitOrder > 0) return explicitOrder;
    for (var i = 0; i < allSections.length; i++) {
      if (allSections[i] === el) return i + 1;
    }
    return 0;
  }

  function observeSections() {
    var sections = Array.from(document.querySelectorAll('[data-aom-section-id]'));
    if (!sections.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var el = entry.target;
          var sectionId = el.dataset.aomSectionId;
          if (!sectionId) return;

          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            if (!fired.has(sectionId)) {
              el._aomSectionTimer = setTimeout(function () {
                if (fired.has(sectionId)) return;
                fired.add(sectionId);
                window.aomTrack('aom_section_view', {
                  section_id: sectionId,
                  section_type: el.dataset.aomSectionType || '',
                  section_order: resolveOrder(el, sections),
                });
              }, 500);
            }

            // Cleared on scroll-away below, so dwell has to be uninterrupted.
            if (!engaged.has(sectionId)) {
              el._aomEngageTimer = setTimeout(function () {
                if (engaged.has(sectionId)) return;
                engaged.add(sectionId);
                window.aomTrack('aom_section_engage', {
                  section_id: sectionId,
                  section_type: el.dataset.aomSectionType || '',
                  section_order: resolveOrder(el, sections),
                });
              }, 2500);
            }
          } else {
            clearTimeout(el._aomSectionTimer);
            clearTimeout(el._aomEngageTimer);
          }
        });
      },
      { threshold: 0.5 }
    );

    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeSections);
  } else {
    observeSections();
  }
})();
